<template>
  <div>
    <iframe
      width="100%"
      :style="{'height': iframeHeight}"
      :src="youtubeLiveEmbedUrl()"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
</template>
<script>
import { getYoutubeLiveEmbedUrl } from "@/helpers";
import i18n from "@/i18n";
export default {
    name: "YoutubeLive",
    props: {
        meta: {
            type: Object,
            default: null
        }
    },
    mounted() {
      this.showNotification()
    },
    computed: {
      iframeHeight() {
        // const isFullScreenWithEmbed = this.meta.isEmbedMode && this.meta.isFullScreenMode
        return this.meta.isFullScreenMode ? '98vh' :'600px'
      }
    },
    methods: {
      youtubeLiveEmbedUrl(autoplay=true){
        return getYoutubeLiveEmbedUrl(this.meta.content, autoplay);
      },
      /** Show notification: Event is about to start */
      showNotification() {
        this.$store.dispatch("app/showSupportNotification", {
          screener_id: this.meta.screener_id,
          message: this.meta.title + i18n.t("screener.meeting.is_about_to_stream")
        });
      }
    }
};
</script>
